import type { SVGProps } from 'react';

interface CurrentLocationPinProps extends SVGProps<SVGSVGElement> {
  pinFill?: string;
  pinStroke?: string;
}

const CurrentLocationPin = ({
  pinFill = '#07036C',
  pinStroke = 'white',
  ...props
}: CurrentLocationPinProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 30 40"
    fill="none"
    {...props}
  >
    <path
      d="M15 1.6C21.476 1.6 27.2 7.325 27.2 14.4c0 2.424-.799 5.012-1.89 7.448-1.1 2.456-2.554 4.877-3.984 6.997-1.433 2.124-2.863 3.976-3.934 5.295a62 62 0 0 1-1.299 1.555 30 30 0 0 1-.369.413l-.026.027-.012.012L15 37.587l-1.187-1.314-.013-.012-.025-.028a30 30 0 0 1-.37-.413 62 62 0 0 1-1.298-1.555c-1.07-1.319-2.5-3.17-3.934-5.295-1.43-2.12-2.884-4.541-3.984-6.997C3.1 19.412 2.3 16.824 2.3 14.4 2.3 7.325 8.024 1.6 15 1.6Z"
      fill={pinFill}
      stroke={pinStroke}
      strokeWidth="3.2"
    />
    <circle cx={15} cy={14.4} r={2.4} fill={pinStroke} />
  </svg>
);

export default CurrentLocationPin;
